export default __webpack_public_path__ + "static/media/date.fcfd3f00.png";